var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconfeatherShoppingBag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_feather-shopping-bag",
    "data-name": "Icon feather-shopping-bag",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.952,
    height: 24.562,
    viewBox: "0 0 20.952 24.562",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M7.19,1.5H19.762a1.027,1.027,0,0,1,.838.447l3.143,4.466a1.166,1.166,0,0,1,.21.67v15.63a3.255,3.255,0,0,1-3.143,3.349H6.143A3.255,3.255,0,0,1,3,22.713V7.082a1.166,1.166,0,0,1,.21-.67L6.352,1.947A1.027,1.027,0,0,1,7.19,1.5ZM19.238,3.733H7.714L5.1,7.454V22.713a1.085,1.085,0,0,0,1.048,1.116H20.809a1.085,1.085,0,0,0,1.048-1.116V7.454Z",
    transform: "translate(-3 -1.5)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M22.9,9.733H4.048a1.119,1.119,0,0,1,0-2.233H22.9a1.119,1.119,0,0,1,0,2.233Z",
    transform: "translate(-3 -3.034)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M15.738,20.2A5.425,5.425,0,0,1,10.5,14.616a1.05,1.05,0,1,1,2.1,0,3.255,3.255,0,0,0,3.143,3.349,3.255,3.255,0,0,0,3.143-3.349,1.05,1.05,0,1,1,2.1,0A5.425,5.425,0,0,1,15.738,20.2Z",
    transform: "translate(-5.262 -4.568)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconfeatherShoppingBag);
export default __webpack_public_path__ + "static/media/Icon feather-shopping-bag.86757477a2c423c1a64afb08ac39ec92.svg";
export { ForwardRef as ReactComponent };